import { render, staticRenderFns } from "./DataManual.vue?vue&type=template&id=49240311&scoped=true"
import script from "./DataManual.vue?vue&type=script&setup=true&lang=js"
export * from "./DataManual.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataManual.vue?vue&type=style&index=0&id=49240311&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49240311",
  null
  
)

export default component.exports